import { last } from 'lodash/fp'

import { FeatureKey } from '@/constants/feature-key'
import {
  FeatureTimezone,
  getFormatedComputerTimezone,
} from '@/constants/timezone'
import { selectCurrentEmployee } from '@/redux/employee-selector'
import { createAppSelector } from '@/redux/utils'
import { dayjs } from '@/utils/dayjs'

export const selectFeatureTimezone = createAppSelector(
  [selectCurrentEmployee, (state) => state.global.featureKeys],
  (currentEmployee, featureKeys) => {
    if ([
      FeatureKey.FansReports,
      FeatureKey.ChattersPerformance,
      FeatureKey.ChatterReportsOverview,
      FeatureKey.ChatterReports,
      FeatureKey.CreatorsPerformance,
      FeatureKey.AnalyticsCreatorOverview,
      FeatureKey.CreatorReports,
      FeatureKey.AnalyticsFanProfilingOverview,
    ].find(key => key === last(featureKeys))) {
      return {
        featureTimezone: currentEmployee?.reportTimezone,
        featureTimezoneName: currentEmployee?.reportTimezoneName,
        featureTimezoneType: FeatureTimezone.ReportTimezone,
      }
    }
    if ([FeatureKey.OFManager].includes(featureKeys[0])) {
      return {
        featureTimezone: getFormatedComputerTimezone(),
        featureTimezoneName: dayjs.tz.guess(),
        featureTimezoneType: FeatureTimezone.ComputerTimezone,
      }
    }
    return {
      featureTimezone: currentEmployee?.regularTimezone,
      featureTimezoneName: currentEmployee?.regularTimezoneName,
      featureTimezoneType: FeatureTimezone.RegularTimezone,
    }
  },
)

